/* TintWhite motion layer */
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia('(pointer: fine)').matches;
  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  /* ---------- word splitting for kinetic type ---------- */
  function splitWords(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      if (!n.nodeValue.trim()) return;
      var frag = document.createDocumentFragment();
      n.nodeValue.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
        var w = document.createElement('span'); w.className = 'tw-w';
        var i = document.createElement('span'); i.className = 'tw-w__i'; i.textContent = part;
        w.appendChild(i); frag.appendChild(w);
      });
      n.parentNode.replaceChild(frag, n);
    });
  }

  ready(function () {
    if (!window.gsap || !window.ScrollTrigger) { document.documentElement.classList.add('tw-nogsap'); return; }
    gsap.registerPlugin(ScrollTrigger);
    document.documentElement.classList.add('tw-gsap');

    /* 1. Kinetic typography */
    if (!REDUCED) {
      document.querySelectorAll('.tw-h1, .tw-h2').forEach(function (h) {
        if (h.dataset.twSplit) return; h.dataset.twSplit = '1';
        splitWords(h);
        var words = h.querySelectorAll('.tw-w__i');
        gsap.set(words, { yPercent: 110, opacity: 0, rotate: 2 });
        gsap.to(words, {
          yPercent: 0, opacity: 1, rotate: 0, duration: 1, ease: 'expo.out', stagger: 0.045,
          scrollTrigger: { trigger: h, start: 'top 88%', once: true }
        });
      });
      /* generic reveals */
      var reveals = document.querySelectorAll('.tw-card, .rsd-card, .tw-step, .tw-ugc__card, .tw-gallery__tile, .tw-bento__tile, .tw-timeline > *, .tw-faq__item, .tw-lead, .tw-check li, .tw-hero__cta, .tw-hero__proof, .rsd-cats__tile, .rsd-stat, .rsd-hero__copy > *');
      ScrollTrigger.batch(reveals, {
        start: 'top 92%', once: true,
        onEnter: function (b) { gsap.fromTo(b, { y: 28, opacity: 0 }, { y: 0, opacity: 1, duration: 0.9, ease: 'expo.out', stagger: 0.08, overwrite: true }); }
      });
      gsap.set(reveals, { opacity: 0 });
    }

    /* 2. Magnetic primary buttons */
    if (FINE && !REDUCED) {
      document.querySelectorAll('.tw-btn--primary, .product-form__submit').forEach(function (b) {
        var strength = 0.35;
        b.addEventListener('pointermove', function (e) {
          var r = b.getBoundingClientRect();
          var x = e.clientX - (r.left + r.width / 2), y = e.clientY - (r.top + r.height / 2);
          gsap.to(b, { x: x * strength, y: y * strength, duration: 0.4, ease: 'power3.out' });
        });
        b.addEventListener('pointerleave', function () { gsap.to(b, { x: 0, y: 0, duration: 0.7, ease: 'elastic.out(1,0.4)' }); });
      });
    }

    /* 3. Sticky buy bar */
    var bar = document.querySelector('.tw-sticky');
    if (bar) {
      var anchor = document.querySelector('.product-form__submit') || document.querySelector('#tw-offer-form') || document.querySelector('.tw-hero__cta');
      if (anchor) {
        ScrollTrigger.create({
          trigger: anchor, start: 'bottom top',
          onEnter: function () { bar.classList.add('is-visible'); },
          onLeaveBack: function () { bar.classList.remove('is-visible'); }
        });
      }
    }

    /* 4. Cart drawer upsell */
    var tpl = document.getElementById('tw-upsell-tpl');
    if (tpl) {
      var variantId = tpl.dataset.variant;
      function inject() {
        var drawer = document.getElementById('CartDrawer'); if (!drawer) return;
        var foot = drawer.querySelector('.drawer__footer'); if (!foot) return;
        if (foot.querySelector('.tw-upsell')) return;
        var hasItems = drawer.querySelector('.cart-item'); if (!hasItems) return;
        var already = Array.prototype.some.call(drawer.querySelectorAll('.cart-item'), function (li) { return (li.innerHTML || '').indexOf('data-tw-upsell') > -1 || (li.textContent || '').indexOf(tpl.dataset.title) > -1; });
        if (already) return;
        var node = tpl.content.firstElementChild.cloneNode(true);
        foot.insertBefore(node, foot.firstChild);
        var btn = node.querySelector('.tw-upsell__btn');
        btn.addEventListener('click', function () {
          btn.disabled = true; btn.textContent = 'Adding...';
          fetch(window.routes.cart_add_url + '.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
          }).then(function (r) { return r.json(); }).then(function (res) {
            var cd = document.querySelector('cart-drawer');
            if (cd && cd.renderContents) cd.renderContents(res); else window.location.href = window.routes.cart_url;
          }).catch(function () { window.location.href = window.routes.cart_url; });
        });
        gsap.from(node, { y: 16, opacity: 0, duration: 0.6, ease: 'expo.out' });
      }
      var host = document.getElementById('CartDrawer');
      if (host) { new MutationObserver(function () { inject(); }).observe(host, { childList: true, subtree: true }); inject(); }
      document.addEventListener('shopify:section:load', inject);
    }

    document.addEventListener('shopify:section:load', function () { ScrollTrigger.refresh(); });
  });
})();
